import * as actions from './base.action';
import inicialState from './base.state';

const baseConhecimentoReducer = (state = inicialState, action) => {
  switch (action.type) {
   
    case actions.BASE_CONHECIMENTO_ATUALIZAR_PAGE:
      return {
        ...state,
        page: action.payload.page,
      };
    case actions.BASE_CONHECIMENTO_ATUALIZAR_FILTRO:
      return {
        ...state,
        filter: action.payload.filter,
      };
   
    default:
      return state;
  }
};

export default baseConhecimentoReducer;



// WEBPACK FOOTER //
// ./src/containers/BaseConhecimento/store/base.reducer.js